import { TableCell } from '@mui/material';

const BSTableHeaderCell = ({ children, hidden, ...props }) => {
  return hidden ? null : (
    <TableCell
      sx={{
        color: 'primary.contrastText',
        fontWeight: 'bold',
        fontSize: 18,
        borderBottom: 'none'
      }}
      {...props}>
      {children}
    </TableCell>
  );
};

export default BSTableHeaderCell;
